import { render, staticRenderFns } from "./ChatMessageChangeChallengeModal.vue?vue&type=template&id=727036dc&"
import script from "./ChatMessageChangeChallengeModal.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageChangeChallengeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports